/**
 * Copyright (c) 2010-2026 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { debounceTime } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { RestService } from '../../../shared/services/rest.service';
import { QueryService } from '../../services/query.service';
import { Observable } from 'rxjs';

@Injectable()
export class LiveSearchService {

    /**
     * @param {RestService} rest
     * @param {QueryService} queryService
     */
    constructor(
        private rest: RestService,
        private queryService: QueryService,
    ) {}

    /**
     * @param searchText
     */
    public search(searchText): Observable<any> {
        const config = {
            query: searchText,
        };
        return this.rest.apiGet('search/live', config).pipe(debounceTime(50));
    }

    public zoom(layerName, keyField, keyValue) {
        this.queryService.zoomTo(layerName, keyField, keyValue);
    }
}
